import { render, staticRenderFns } from "./turnover-list.vue?vue&type=template&id=476da026&scoped=true&"
import script from "./turnover-list.vue?vue&type=script&lang=ts&"
export * from "./turnover-list.vue?vue&type=script&lang=ts&"
import style0 from "./turnover-list.vue?vue&type=style&index=0&id=476da026&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476da026",
  null
  
)

export default component.exports